import type { TemplateOnlyComponent } from '@ember/component/template-only';

export interface Signature {
  Args: {
    class?: string;
  };
  Element: SVGElement;
}

const WrDoubleArrowRightIconComponent: TemplateOnlyComponent<Signature> =
  <template>
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      class={{@class}}
      ...attributes
    >
      <path
        d='M7.49162 13.7249C7.17877 14.0372 7.17877 14.4535 7.49162 14.7658C7.80447 15.0781 8.2216 15.0781 8.53445 14.7658L14.7914 8.52045C14.8957 8.41636 15 8.20818 15 8C15 7.79182 14.8957 7.58364 14.7914 7.47955L8.53445 1.2342C8.2216 0.921933 7.80447 0.921933 7.49162 1.2342C7.17877 1.54647 7.17877 1.96283 7.49162 2.27509L13.2272 8L7.49162 13.7249ZM6.97021 8L1.23464 2.27509C0.921789 1.96283 0.921789 1.54647 1.23464 1.2342C1.54749 0.921933 1.96462 0.921933 2.27747 1.2342L8.53445 7.47955C8.63873 7.58364 8.74302 7.79182 8.74302 8C8.74302 8.20818 8.63873 8.41636 8.53445 8.52045L2.27747 14.7658C1.96462 15.0781 1.54749 15.0781 1.23464 14.7658C0.921789 14.4535 0.921789 14.0372 1.23464 13.7249L6.97021 8Z'
        fill='currentColor'
      />
    </svg>
  </template>;

export default WrDoubleArrowRightIconComponent;
